export const gameName = 'magicdice';
